import { PlayerJumpShipReasonType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const playerJumpShipReasonName: { [key in PlayerJumpShipReasonType]: TKeyType } = {
  // 如果使用 Object.keys 的方式獲取 playerJumpShipReasonName中的key，需注意後端沒有 PlayerJumpShipReasonType.REGISTER 這個enum，需要進行filter
  [PlayerJumpShipReasonType.REGISTER]: 'common.register',
  [PlayerJumpShipReasonType.PLAYER_TO_PLATFORM]: 'playerJumpShipReason.playerToPlatform',
  [PlayerJumpShipReasonType.LONG_TIME_NO_LOGIN]: 'playerJumpShipReason.longTimeNoLogin',
  [PlayerJumpShipReasonType.STUPID_PLAYER]: 'playerJumpShipReason.stupidPlayer',
  [PlayerJumpShipReasonType.ABANDON_PLAYER]: 'playerJumpShipReason.abandonPlayer',
  [PlayerJumpShipReasonType.CUSTOM]: 'common.custom'
}

export default playerJumpShipReasonName
